import { VuexHelper } from '@amarkets/atlas/esm/lib/vuex-helper';
import createActions from './actions';

export default function (context) {
  return VuexHelper.createStoreModule({
    actions: [createActions(context)],
  });
}
